import api from "./api";

const feedbackService = {
  create: async (payload, token) => {
    const res = await api.post("/feedback", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getAll: async (token, params = {}) => {
    const res = await api.get("/feedback", {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getSsdiAll: async (token, params = {}) => {
    const res = await api.get("/feedback/ssdi", {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};

export default feedbackService;
